import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import MobileBottomNav from '../components/MobileBottomNav';
import { RefreshableSection } from '../components/shared/SectionRefresh';
import DashboardOverview from '../components/admin/DashboardOverview';
import RidesManagement from '../components/admin/RidesManagement';
import PastRides from '../components/admin/PastRides';
import UserManagement from '../components/admin/UserManagement';
import Partners from '../components/admin/Partners';
import Expenses from '../components/admin/Expenses';
import Petrol from '../components/admin/Petrol';
import Statistics from '../components/admin/Statistics';
import Settings from '../components/admin/Settings';
import DataBackup from '../components/admin/DataBackup';
import Integrations from '../components/admin/Integrations';
import CompanyFinancials from '../components/admin/CompanyFinancials';
import CompanyDebts from '../components/admin/CompanyDebts';
import PricingRules from '../components/admin/PricingRules';
import VehicleManagement from '../components/admin/VehicleManagement';
import DailyVouchers from '../components/admin/DailyVouchers';
import PartnerReports from '../components/admin/PartnerReports';
import CarWashAdmin from '../components/admin/CarWashAdmin';
import DriverAttendance from '../components/admin/DriverAttendance';
import ActionLog from '../components/admin/ActionLog';
import WebhookEvents from '../components/admin/WebhookEvents';
import TransferzOffers from '../components/admin/TransferzOffers';
import TransferzJourneys from '../components/admin/TransferzJourneys';
import TransferzTestRides from '../components/admin/TransferzTestRides';

export default function AdminDashboard() {
  return (
    <div className="flex h-screen bg-blue-50">
      {/* Desktop Sidebar - Hidden on mobile */}
      <Sidebar />
      
      {/* Main Content Area */}
      <div className="flex-1 overflow-auto pb-16 lg:pb-0">
        <RefreshableSection>
        <Routes>
          <Route path="/" element={<DashboardOverview />} />
          <Route path="/rides" element={<RidesManagement />} />
          <Route path="/past-rides" element={<PastRides />} />
          <Route path="/users" element={<UserManagement />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/pricing" element={<PricingRules />} />
          <Route path="/vehicles" element={<VehicleManagement />} />
          <Route path="/expenses" element={<Expenses />} />
          <Route path="/petrol" element={<Petrol />} />
          <Route path="/car-wash" element={<CarWashAdmin />} />
          <Route path="/attendance" element={<DriverAttendance />} />
          <Route path="/statistics" element={<Statistics />} />
          <Route path="/financials" element={<CompanyFinancials />} />
          <Route path="/debts" element={<CompanyDebts />} />
          <Route path="/daily-vouchers" element={<DailyVouchers />} />
          <Route path="/partner-reports" element={<PartnerReports />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/backup" element={<DataBackup />} />
          <Route path="/action-log" element={<ActionLog />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/webhook-events" element={<WebhookEvents />} />
          <Route path="/transferz-offers" element={<TransferzOffers />} />
          <Route path="/transferz-journeys" element={<TransferzJourneys />} />
          <Route path="/transferz-test-rides" element={<TransferzTestRides />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
        </RefreshableSection>
      </div>
      
      {/* Mobile Bottom Navigation - Hidden on desktop */}
      <MobileBottomNav />
    </div>
  );
}